export default __webpack_public_path__ + "static/news-aaa6f80974f173920359caa1a5287ef2.jpeg";